import i18next from 'i18next'
import * as React from 'react'
import { SubscriptionData } from '../../sharepointPageApi/types/pageData'
import { InviewProps } from '../blocksState'

export type AllSubscriptionsBlockProps = {
  index: number
  inview?: InviewProps
  title?: React.ReactNode
  children: SubscriptionData[]
}

const toLocaleString = (price: number | null): string => {
  if (!price) {
    return ''
  }
  const round = price % 1 === 0

  return `${price.toLocaleString('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: round ? 0 : 2
  })}${round ? ',-' : ''}`
}
export function AllSubscriptionsBlockLayout(props: AllSubscriptionsBlockProps) {
  return props.children.length > 0 ? (
    <>
      <section className={`block block--memberships spacing--m ${props.children.length < 4 ? ' centered' : ''}`}>
        <div className="block__inner spacing--mx gutter--m">
          <header className="block__header container--mx">
            <h2 className="block__title title--m">{props.title}</h2>
          </header>

          <div className="block__content container--mx">
            <ul className="memberships">
              {props.children.map(c => (
                <li className="memberships__item">
                  <a href='/lidmaatschapsprijzen' className="memberships__link">
                    <div className="memberships__header">
                      <h3 className="memberships__type title--xs">{c.Title}</h3>
                    </div>
                    <p className="memberships__meta text--xxs">{c.Subtitle}</p>
                    <p className="memberships__price title--xs">
                      {toLocaleString(c.MembershipPrice)}
                      <span className="memberships__interval text--xxs">
                        {i18next.t('subscriptions:month')}
                      </span>
                    </p>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  ) : null
}
